import { isServerSide } from './env';

/**
 * 获取语言设置
 */
export const getLanguage = async (): Promise<string> => {
  if (isServerSide()) {
    // 服务端：从 headers 获取
    try {
      const { headers } = await import('next/headers');
      const headersList = await headers();
      const language = headersList.get('x-language');
      return language || 'en';
    } catch {
      return 'en';
    }
  } else {
    // 客户端：从 location 获取
    return globalThis?.location?.href?.includes?.('/zh/') ? 'zh' : 'en';
  }
};
